import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './lang/index';
import scroll from './plugs/scroll';
import VueSocialSharing from './plugs/vue-social-sharing/src/vue-social-sharing.js';

createApp(App).use(store).use(router).use(i18n).use(scroll).use(VueSocialSharing).mount('#app');
